import * as Portal from '@radix-ui/react-portal';

import {useIsHydrated} from '~/hooks/useIsHydrated';

/**
 * A Radix portal that only mounts once the page has hydrated.
 *
 * @radix-ui/react-portal 1.0.2 renders nothing on the server (there is no
 * `document`) and a portal on the client's very first render. That first
 * render IS the hydration pass, so an always-mounted <Portal.Root> made React
 * find a node the server never sent: error #418, then #423, and React threw
 * away the entire server-rendered document and rebuilt it on the client.
 * That happened on every page — the member drawer is in the sidebar — and it
 * is what set LCP, not the images.
 *
 * Every caller here only shows its portal content after a click, so waiting
 * one effect tick for hydration changes nothing a visitor can see.
 */
export default function ClientPortal(
  props: React.ComponentProps<typeof Portal.Root>,
) {
  const isHydrated = useIsHydrated();
  return isHydrated ? <Portal.Root {...props} /> : null;
}
